import { View } from 'react-native';

export const SafeAreaView = View;